// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* to fix overscroll issue */
html {
  height: 100%;
  overflow: hidden;
}
body {
  height: 100%;
  overflow: auto !important;
}

.scrollbar-dark {
  overflow: auto;
  scrollbar-color: #ffffff transparent;
}
.scrollbar-dark::-webkit-scrollbar {
  width: 4px;
}
.scrollbar-dark::-webkit-scrollbar-track {
  color: transparent;
  width: 4px;
}

.scrollbar-dark::-webkit-scrollbar-thumb {
  background: #ffffff4d;
  border-radius: 4px;
}

.scrollbar-dark::-webkit-scrollbar-thumb:hover {
  background: #e5e7eb;
  border-radius: 4px;
}

.scrollbar-light {
  overflow: auto;
  scrollbar-color: #dce3ef transparent;
}
.scrollbar-light::-webkit-scrollbar {
  width: 4px;
}
.scrollbar-light::-webkit-scrollbar-track {
  color: transparent;
  width: 4px;
}

.scrollbar-light::-webkit-scrollbar-thumb {
  background: #dce3ef;
  border-radius: 4px;
}

.scrollbar-light::-webkit-scrollbar-thumb:hover {
  background: #e5e7eb;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/scrollbar.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* to fix overscroll issue */\nhtml {\n  height: 100%;\n  overflow: hidden;\n}\nbody {\n  height: 100%;\n  overflow: auto !important;\n}\n\n.scrollbar-dark {\n  overflow: auto;\n  scrollbar-color: #ffffff transparent;\n}\n.scrollbar-dark::-webkit-scrollbar {\n  width: 4px;\n}\n.scrollbar-dark::-webkit-scrollbar-track {\n  color: transparent;\n  width: 4px;\n}\n\n.scrollbar-dark::-webkit-scrollbar-thumb {\n  background: #ffffff4d;\n  border-radius: 4px;\n}\n\n.scrollbar-dark::-webkit-scrollbar-thumb:hover {\n  background: #e5e7eb;\n  border-radius: 4px;\n}\n\n.scrollbar-light {\n  overflow: auto;\n  scrollbar-color: #dce3ef transparent;\n}\n.scrollbar-light::-webkit-scrollbar {\n  width: 4px;\n}\n.scrollbar-light::-webkit-scrollbar-track {\n  color: transparent;\n  width: 4px;\n}\n\n.scrollbar-light::-webkit-scrollbar-thumb {\n  background: #dce3ef;\n  border-radius: 4px;\n}\n\n.scrollbar-light::-webkit-scrollbar-thumb:hover {\n  background: #e5e7eb;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
